function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".error-data-table__scroll", shadowSelector, " {padding-top: 20px;height: 48.5vh;overflow: scroll;}"].join('');
}
export default [stylesheet];